// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `svg:not(:root) {
  position: relative;
}

.strike {
  display: block;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  top: 80%;
}

.strike > span {
  position: relative;
  display: inline-block;
}

.strike > span:before,
.strike > span:after {
  content: "";
  position: absolute;
  top: 78%;
  width: 250px;
  height: 1px;
  background: #2B3761;
}

.strike > span:before {
  right: 70%;
  margin-right: 55px;
}

.strike > span:after {
  left: 70%;
  margin-left: 55px;
}

@media screen and (min-width: 0px) and (max-width: 780px) {
  #my-content-1 {
    display: none;
  }
}
@media screen and (min-width: 781px) {
  #my-content-2 {
    display: none;
  }
  .right-content {
    top: 130px;
  }
}
svg {
  min-height: 120px;
}

.fix-min-height {
  min-height: 350px;
}

.pos-bottom {
  position: absolute;
  bottom: 20px;
  width: 100%;
}

.center-pad {
  padding-top: 60px;
  padding-bottom: 70px;
}

.text-label {
  margin-top: 6px;
}

.remove-input-border {
  background-image: none;
  font-weight: 400;
  font-size: 16px;
}

@media screen and (min-width: 0px) and (max-width: 952px) {
  .center-pad {
    padding-top: 30px;
  }
}
.no-border {
  border: none;
}

.no-margin-top-bottom {
  margin-top: 0;
  margin-bottom: 0;
}

.textarea {
  white-space: pre-wrap;
}

.StripeElement {
  box-sizing: border-box;
  height: 40px;
  padding: 10px 12px;
  border-radius: 4px;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

form.checkout {
  margin: 2rem auto;
  text-align: center;
  border: 2px solid #eee;
  padding: 3px;
  background-color: #EBF1F7;
  font-family: monospace;
  color: #525252;
  font-size: 1.1rem;
  opacity: 0;
  transform: scale(0.8);
  will-change: opacity, transform;
}

form.checkout button {
  width: 100%;
  padding: 0.5rem 1rem;
  color: white;
  background: rgb(26, 127, 203);
  border: none;
  font-weight: 500;
  font-size: 16px;
}

form.checkout button:active {
  background: rgb(23, 82, 137);
}

label {
  color: #8898aa;
  font-size: 13.5px;
}

#form-field {
  padding: 3px;
  background-color: white !important;
}

#card-info {
  min-width: 400px;
}

mat-error {
  display: flex;
  align-items: center;
  justify-content: center;
}

#card-errors {
  padding: 3px;
  font-size: 13px;
}

.image {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-top: 76px;
}

.cards {
  overflow: hidden;
  position: relative;
  padding: 0 10px;
  height: 55px;
  margin-left: 10px;
}

.cards > div {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.cards > div > img {
  margin-right: 20px;
}

#information-message {
  color: #67656b;
  font-size: 0.71rem;
  padding: 10px 0;
}

#submit-button {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: 0.2s;
  font-weight: 600;
}

#submit-button:hover {
  background-color: rgb(73, 153, 215);
}

#info-icon {
  margin-left: 5px;
}

.cards img {
  width: 55px;
}

@media screen and (max-width: 650px) {
  ::ng-deep .cdk-overlay-pane {
    max-width: 100% !important;
    min-width: 95vw !important;
  }
  ::ng-deep mat-dialog-container {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }
  form {
    width: 95%;
  }
  form.checkout {
    padding: 1rem 5px !important;
  }
  .image {
    flex-direction: column;
  }
  .cards {
    margin-top: 10px;
  }
  .cards img {
    width: 15%;
  }
  #card-info {
    min-width: 100%;
  }
}
.payment-form {
  animation-delay: 0.3s;
  animation-name: payment-form;
  animation-duration: 0.4s;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}

@keyframes payment-form {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
.payment-methods {
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding: 15px;
  transition: 0.2s;
}

.payment-methods:hover {
  background-color: rgba(0, 0, 0, 0.07);
}

.card-details {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 19px;
}

.card-name {
  font-size: 19px;
  font-weight: 600;
  font-style: italic;
  color: #303238;
}

@media only screen and (max-width: 800px) {
  .payment-methods {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/orders/orderFly/order-fly.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,kBAAA;EACA,qBAAA;AACF;;AAEA;;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AACF;;AAEA;EACE,UAAA;EACA,kBAAA;AACF;;AAEA;EACE,SAAA;EACA,iBAAA;AACF;;AAEA;EACE;IACE,aAAA;EACF;AACF;AAEA;EACE;IACE,aAAA;EAAF;EAEA;IACE,UAAA;EAAF;AACF;AAGA;EACE,iBAAA;AADF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AADF;;AAIA;EACE,iBAAA;EACA,oBAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,sBAAA;EACA,gBAAA;EACA,eAAA;AADF;;AAIA;EACE;IACE,iBAAA;EADF;AACF;AAIA;EACE,YAAA;AAFF;;AAKA;EACE,aAAA;EACA,gBAAA;AAFF;;AAKA;EACE,qBAAA;AAFF;;AAKA;EACE,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EAEA,iCAAA;AAFF;;AAKA;EACE,+BAAA;AAFF;;AAKA;EACE,qBAAA;AAFF;;AAKA;EACE,oCAAA;AAFF;;AAMA;EAEE,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;EACA,qBAAA;EACA,+BAAA;AAJF;;AAOA;EACE,WAAA;EACA,oBAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;EAEA,gBAAA;EACA,eAAA;AALF;;AAQA;EACE,4BAAA;AALF;;AAQA;EACE,cAAA;EACA,iBAAA;AALF;;AAQA;EACE,YAAA;EACA,kCAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AALF;;AAQA;EACE,YAAA;EACA,eAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AALF;;AAQA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AALF;;AAQA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AALF;;AAQA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AALF;;AAQA;EACE,mCAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,WAAA;AALF;;AASA;EAEE;IACE,0BAAA;IACA,0BAAA;EAPF;EAUA;IACE,4BAAA;IACA,6BAAA;EARF;EAWA;IACE,UAAA;EATF;EAYA;IACE,4BAAA;EAVF;EAaA;IACE,sBAAA;EAXF;EAcA;IACE,gBAAA;EAZF;EAeA;IACE,UAAA;EAbF;EAgBA;IACE,eAAA;EAdF;AACF;AAmBA;EACE,qBAAA;EACA,4BAAA;EACA,wBAAA;EACA,iCAAA;EACA,6BAAA;AAjBF;;AAoBA;EACE;IACE,UAAA;IACA,qBAAA;EAjBF;EAoBA;IACE,UAAA;IACA,mBAAA;EAlBF;AACF;AAsBA;EACE,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,4CAAA;EACA,aAAA;EACA,gBAAA;AApBF;;AAuBA;EACE,qCAAA;AApBF;;AAuBA;EACE,2DAAA;EACA,eAAA;AApBF;;AAuBA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AApBF;;AAwBA;EACE;IACE,sBAAA;EArBF;AACF","sourcesContent":["svg:not(:root) {\n  position: relative;\n}\n\n.strike {\n  display: block;\n  text-align: center;\n  overflow: hidden;\n  white-space: nowrap;\n  top: 80%;\n}\n\n.strike > span {\n  position: relative;\n  display: inline-block;\n}\n\n.strike > span:before,\n.strike > span:after {\n  content: \"\";\n  position: absolute;\n  top: 78%;\n  width: 250px;\n  height: 1px;\n  background: #2B3761;\n}\n\n.strike > span:before {\n  right: 70%;\n  margin-right: 55px;\n}\n\n.strike > span:after {\n  left: 70%;\n  margin-left: 55px;\n}\n\n@media screen and (min-width: 0px) and (max-width: 780px) {\n  #my-content-1 {\n    display: none;\n  }\n}\n\n@media screen and (min-width: 781px) {\n  #my-content-2 {\n    display: none;\n  }\n  .right-content {\n    top: 130px\n  }\n}\n\nsvg {\n  min-height: 120px\n}\n\n.fix-min-height {\n  min-height: 350px;\n}\n\n.pos-bottom {\n  position: absolute;\n  bottom: 20px;\n  width: 100%;\n}\n\n.center-pad {\n  padding-top: 60px;\n  padding-bottom: 70px;\n}\n\n.text-label {\n  margin-top: 6px;\n}\n\n.remove-input-border {\n  background-image: none;\n  font-weight: 400;\n  font-size: 16px;\n}\n\n@media screen and (min-width: 0px) and (max-width: 952px) {\n  .center-pad {\n    padding-top: 30px;\n  }\n}\n\n.no-border {\n  border: none;\n}\n\n.no-margin-top-bottom {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.textarea {\n  white-space: pre-wrap;\n}\n\n.StripeElement {\n  box-sizing: border-box;\n  height: 40px;\n  padding: 10px 12px;\n  border-radius: 4px;\n  -webkit-transition: box-shadow 150ms ease;\n  transition: box-shadow 150ms ease;\n}\n\n.StripeElement--focus {\n  box-shadow: 0 1px 3px 0 #cfd7df;\n}\n\n.StripeElement--invalid {\n  border-color: #fa755a;\n}\n\n.StripeElement--webkit-autofill {\n  background-color: #fefde5 !important;\n}\n\n// for stripe form\nform.checkout {\n  //max-width: 500px;\n  margin: 2rem auto;\n  text-align: center;\n  border: 2px solid #eee;\n  padding: 3px;\n  background-color: #EBF1F7;\n  font-family: monospace;\n  color: #525252;\n  font-size: 1.1rem;\n  opacity: 0;\n  transform: scale(0.8);\n  will-change: opacity, transform;\n}\n\nform.checkout button {\n  width: 100%;\n  padding: 0.5rem 1rem;\n  color: white;\n  background: rgb(26, 127, 203);\n  border: none;\n  //margin-top: 1rem;\n  font-weight: 500;\n  font-size: 16px;\n}\n\nform.checkout button:active {\n  background: rgb(23, 82, 137);\n}\n\nlabel {\n  color: #8898aa;\n  font-size: 13.5px;\n}\n\n#form-field {\n  padding: 3px;\n  background-color: white !important;\n}\n\n#card-info {\n  min-width: 400px;\n}\n\nmat-error {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n#card-errors {\n  padding: 3px;\n  font-size: 13px;\n}\n\n.image {\n  width: 100%;\n  height: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  margin-top: 76px;\n}\n\n.cards {\n  overflow: hidden;\n  position: relative;\n  padding: 0 10px;\n  height: 55px;\n  margin-left: 10px;\n}\n\n.cards > div {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n\n.cards > div > img {\n  margin-right: 20px;\n}\n\n#information-message {\n  color: #67656b;\n  font-size: 0.71rem;\n  padding: 10px 0;\n}\n\n#submit-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: 0.2s;\n  font-weight: 600;\n}\n\n#submit-button:hover {\n  background-color: rgb(73, 153, 215);\n}\n\n#info-icon {\n  margin-left: 5px;\n}\n\n.cards img {\n  width: 55px;\n}\n\n\n@media screen and (max-width: 650px) {\n\n  ::ng-deep .cdk-overlay-pane {\n    max-width: 100% !important;\n    min-width: 95vw !important;\n  }\n\n  ::ng-deep mat-dialog-container {\n    padding-left: 4px !important;\n    padding-right: 4px !important;\n  }\n\n  form {\n    width: 95%;\n  }\n\n  form.checkout {\n    padding: 1rem 5px !important;\n  }\n\n  .image {\n    flex-direction: column;\n  }\n\n  .cards {\n    margin-top: 10px;\n  }\n\n  .cards img {\n    width: 15%;\n  }\n\n  #card-info {\n    min-width: 100%;\n  }\n}\n\n\n// payment form animation\n.payment-form {\n  animation-delay: .3s;\n  animation-name: payment-form;\n  animation-duration: .4s;\n  animation-timing-function: linear;\n  animation-fill-mode: forwards;\n}\n\n@keyframes payment-form {\n  0% {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n\n.payment-methods {\n  border-radius: 4px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n  padding: 15px;\n  transition: 0.2s;\n}\n\n.payment-methods:hover {\n  background-color: rgba(0, 0, 0, 0.07);\n}\n\n.card-details {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 19px;\n}\n\n.card-name {\n  font-size: 19px;\n  font-weight: 600;\n  font-style: italic;\n  color: #303238;\n}\n\n\n@media only screen and (max-width: 800px) {\n  .payment-methods {\n    flex-direction: column;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
